import { MapConstants } from '../../../../../utils/map.constant';

export const WindspeedMapConstants = {
  CommonLayers: [
    {
      layerNameType: 'STATE',
      serviceType: 'WmsLayer',
      view: 'Both',
      type: 'Base',
      env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      pane: 'state',
      styles: 'INDIA_STATE_NAMES',
      minZoom: 5,
    }
  ],
  PrimarySourceType: 'IMD_SHORT_RANGE',
  SecondarySourceType: 'IMD_LONG_RANGE',
  HeatMapUrl: 'weatherForecast/getHeatMapData/',
  HeatMapOptions: {
    type: 'Time',
    clip: false,
    view: 'Admin',
    serviceType: 'HeatMap'
  },
  ShortRangeURLConstant: 'WINDSHORTRANGEIMDMAP',
  LongRangeURLConstant: 'WINDLONGRANGEIMDMAP',
  WindUrl: 'weatherForecast/getWindData/',
  WindLayerOptions: {
    type: 'Time',
    serviceType: 'WindLayer'
  },
  WindShortRangeURLConstant: 'WINDDATASR',
  WindLongRangeURLConstant: 'WINDDATALR',
  CityLayerOptions: {
    type: 'Time',
    componentMeasureUnit: '',
    componentType: 'wg',
    color: 'color:#FFFFFF',
    serviceType: 'GeoJsonTileLayer'
  },
  CityURLConstant: 'weatherForecast/getForecastLayer',
  legendData: {
    levels: [
      {
        color: '#ffffff',
        name: 'kmph'
      },
      {
        color: '#C91724',
        name: '160'
      },
      {
        color: '#D62E2F',
        name: '120'
      },
      {
        color: '#E14339',
        name: '100'
      },
      {
        color: '#E66D41',
        name: '80'
      },
      {
        color: '#E39E45',
        name: '70'
      },
      {
        color: '#BBD04C',
        name: '60'
      },
      {
        color: '#73D85D',
        name: '50'
      },
      {
        color: '#4CD37F',
        name: '40'
      },
      {
        color: '#41C6AA',
        name: '30'
      },
      {
        color: '#3FB1C4',
        name: '20'
      },
      {
        color: '#479BC5',
        name: '10'
      },
      {
        color: '#4D86C5',
        name: '5'
      }
    ]
  },
  componentName: 'WIND',
  days10ForecastLength: '10',
  days24ForecastLength: '24',
  basinGeoJSONUrl: MapConstants.GEOSERVER_WMFS_URL + 'forecast%3AANDHRA%20PRADESH_BASIN',
  SOURCE_LIST: [
    {
      source: 'IMD',
      forecastLengthList: ['24', '10']
    },
  ]
};
